import type { TooltipContent, TooltipOptions } from '../../types'

export function useTooltip(
  content: MaybeRefOrGetter<TooltipContent>,
  options?: TooltipOptions,
) {
  return computed(() => ({
    content: toValue(content),
    html: true,
    placement: 'bottom',
    triggers: ['hover', 'click'],
    theme: 'redesign',
    ...options,
  }))
}
